export function fromS3ToResizedUrl(photo: string | undefined) {
  if (!photo || !photo.includes('presigned_s3_get')) return undefined
  const cleanUrl = photo.split('presigned_s3_get')[1]
  const [_, objectType, objectId, fileName] = cleanUrl.split('/')
  return { objectType, objectId, fileName }
}
